import { SxProps, Theme } from '@mui/material';

export const containerSX: SxProps<Theme> = {
	width: '360px',
	maxWidth: '100vw',
	height: 'calc(100dvh - var(--mini-cart-top, 66px))',
	boxSizing: 'border-box',
	display: 'flex',
	flexDirection: 'column',
	overflow: 'hidden',
	backgroundColor: '#FFFFFF',
	paddingY: 'var(--spacing-5)',
	position: 'fixed',
	top: 'var(--mini-cart-top, 66px)',
	right: 0,
	borderRadius: 0,
	boxShadow: '0px 16px 16px -8px rgba(0,0,0,0.12), -8px 8px 16px -8px rgba(0,0,0,0.12)',
};

export const scrollAreaSX: SxProps<Theme> = {
	flex: 1,
	minHeight: 0,
	display: 'flex',
	flexDirection: 'column',
	paddingX: 'var(--spacing-5)',
};

export const totalRowSX: SxProps<Theme> = {
	position: 'sticky',
	bottom: 0,
	marginTop: '-8px',
	backgroundColor: '#FFFFFF',
	zIndex: 1,
	paddingTop: 'var(--spacing-2)',
	paddingBottom: 'var(--spacing-2)',
};

export const recommendationsWrapperSX: SxProps<Theme> = {
	flexShrink: 1,
	minHeight: 0,
	overflow: 'hidden',
	backgroundColor: '#F7F7F7',
	paddingX: 'var(--spacing-5)',
	paddingY: 'var(--spacing-2)',
};

export const totalRowDividerSX: SxProps<Theme> = {
	marginBottom: 'var(--spacing-2)',
};

export const recommendationsDividerSX: SxProps<Theme> = {
	flexShrink: 0,
	marginTop: 'var(--spacing-1)',
};

export const recommendationsInnerSX: SxProps<Theme> = {
	marginRight: '-40px',
	paddingRight: '20px',
};

export const recommendationsTitleSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-body)',
	fontWeight: 800,
	color: '#2C2C2C',
	marginBottom: '11px',
	textTransform: 'uppercase',
};

export const headerRowSX: SxProps<Theme> = {
	flexShrink: 0,
	justifyContent: 'space-between',
	alignItems: 'center',
	marginBottom: 'var(--spacing-4)',
	paddingX: 'var(--spacing-5)',
};

export const headerTitleSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-small)',
	color: '#2C2C2C',
	display: 'flex',
	alignItems: 'center',
	textTransform: 'uppercase',
	fontWeight: 800,
};

export const headerIconImageSX: SxProps<Theme> = {
	height: '16px',
	width: '16px',
	marginRight: '8px',
};

export const closeIconSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-body)',
	cursor: 'pointer',
	marginRight: '-6px',
};

export const itemsStackSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	flex: 1,
	minHeight: 0,
	overflowY: 'auto',
	'&::-webkit-scrollbar': {
		width: '4px',
		backgroundColor: '#f0f0f0',
	},
	'&::-webkit-scrollbar-thumb': {
		backgroundColor: '#888',
		borderRadius: '10px',
	},
};

export const cartFooterSX: SxProps<Theme> = {
	flexShrink: 0,
	marginTop: 'var(--spacing-4)',
	display: 'flex',
	flexDirection: 'column',
	backgroundColor: '#FFFFFF',
	paddingX: 'var(--spacing-5)',
};

export const productCountSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-small)',
};

export const productCountNumberSX: SxProps<Theme> = {
	fontWeight: 800,
};

export const actionsStackSX: SxProps<Theme> = {
	marginTop: 'var(--spacing-5)',
};

export const cartButtonSX: SxProps<Theme> = {
	backgroundColor: '#F1F1F1',
	color: '#2C2C2C',
	borderRadius: 50,
	height: '38px',
	paddingX: 'var(--spacing-5)',
	fontWeight: 600,
	fontSize: 'var(--font-size-body)',
	width: '100%',
};

export const checkoutButtonSX: SxProps<Theme> = {
	width: '100%',
	backgroundColor: '#FF4900',
	color: '#FFFFFF',
	borderRadius: 50,
	height: '38px',
	paddingX: 'var(--spacing-5)',
	fontWeight: 600,
	fontSize: 'var(--font-size-body)',
	':disabled': {
		backgroundColor: '#B5B5B5',
		color: '#FFFFFF',
	},
};

export const emptyContainerSX: SxProps<Theme> = {
	width: '290px',
	padding: 'var(--spacing-5)',
	backgroundColor: '#FFFFFF',
	borderRadius: '0px 0px 6px 6px',
	position: 'relative',
	marginTop: '-20px',
};

export const emptyMessageSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-small)',
};

export const emptyCloseIconSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-body)',
	cursor: 'pointer',
	marginRight: '-6px',
	color: 'rgb(146, 146, 146)',
	position: 'absolute',
	top: '7px',
	right: '15px',
};
